import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Crown } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] overflow-hidden">
      {/* Background Gradient */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #1e3a5f 0%, #152a42 50%, #0f1f30 100%)'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <div className="w-8 h-8 bg-amber-500/20 rounded-full flex items-center justify-center">
              <Crown className="w-4 h-4 text-amber-400" />
            </div>
            <span className="text-white/90 text-sm font-medium">Premium Custom Printing</span>
          </div>

          {/* Heading */}
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Wear Your{' '}
            <span className="text-amber-400 italic">Crown</span>
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-10 max-w-xl">
            Custom apparel and accessories that make a statement. Quality printing for those who demand excellence.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-12">
            <Link to="/shop">
              <Button 
                className="bg-amber-500 hover:bg-amber-600 text-gray-900 font-semibold px-8 py-6 text-base rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/25"
              >
                Shop Collection
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/shop?category=custom">
              <Button 
                variant="outline"
                className="border-2 border-white/30 bg-transparent hover:bg-white/10 text-white font-semibold px-8 py-6 text-base rounded-lg transition-all duration-300"
              >
                Custom Orders
              </Button>
            </Link>
          </div>

          {/* Features */}
          <div className="flex flex-wrap gap-6 md:gap-10">
            {[
              'Premium Materials',
              'Fast Turnaround',
              'Satisfaction Guaranteed'
            ].map((feature) => (
              <div key={feature} className="flex items-center gap-2">
                <div className="w-2 h-2 bg-amber-400 rounded-full" />
                <span className="text-gray-400 text-sm">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
